import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export type NumberLocale = 'en-US' | 'ro-RO';
export const DEFAULT_NUMBER_LOCALE: NumberLocale = 'en-US';

interface FormatPrefsStore {
  numberFormat: NumberLocale;
  setNumberFormat: (v: NumberLocale) => void;
  reset: () => void;
}

/**
 * Preferință per-user de format numeric (en-US `1,234.56` vs ro-RO `1.234,56`).
 * Persistat în localStorage (Zustand persist) + oglindit în DB
 * (`User.appearancePrefs.formatPrefs`) prin `appearance-prefs-sync` pentru
 * cross-device. Aplicat în UI prin `<NumberFormatProvider>` → `setNumberLocale`.
 */
export const useFormatPrefsStore = create<FormatPrefsStore>()(
  persist(
    (set) => ({
      numberFormat: DEFAULT_NUMBER_LOCALE,
      setNumberFormat: (v) => set({ numberFormat: v }),
      reset: () => set({ numberFormat: DEFAULT_NUMBER_LOCALE }),
    }),
    {
      name: 'sf-format-prefs',
      storage: createJSONStorage(() =>
        typeof window !== 'undefined'
          ? localStorage
          : ({ getItem: () => null, setItem: () => {}, removeItem: () => {} } as unknown as Storage),
      ),
      partialize: (state) => ({ numberFormat: state.numberFormat }),
    },
  ),
);
